export class IziviaBusinessError extends Error {
    constructor(message: string) {
        super(message);
        this.name = 'IziviaBusinessError';
        // Set the prototype explicitly. (fix `error instanceof IziviaMapError` not working)
        Object.setPrototypeOf(this, IziviaBusinessError.prototype);
    }
}
